import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { SiteNav, MinimalFooter } from '../homev2/shared';

export const localization = {
  signIn: {
    start: {
      titleCombined: 'Willkommen bei hamba',
      subtitleCombined: 'Bitte melden Sie sich mit Ihren Zugangsdaten an.',
    },
  },
  formFieldLabel__emailAddress_username: 'E-Mail Adresse',
  formFieldInputPlaceholder__emailAddress_username: 'E-Mail',
  formFieldLabel__password: 'Ihr Passwort',
  formFieldInputPlaceholder__password: 'Passwort',
  formButtonPrimary: 'Anmelden',
};

// Clerk appearance — aligned to the new editorial palette (bordeaux / cream / Cormorant).
const clerkAppearance = {
  variables: {
    colorPrimary: '#5A2A2A',
    colorBackground: '#F5F2EC',
    colorText: '#2C2F36',
    colorTextSecondary: '#6B6E76',
    colorInputBackground: '#F5F2EC',
    colorInputText: '#1A1D24',
    colorDanger: '#5A2A2A',
    fontFamily: 'Inter, -apple-system, system-ui, sans-serif',
    fontFamilyButtons: 'Inter, -apple-system, system-ui, sans-serif',
    borderRadius: '1px',
    fontSize: '15px',
  },
  elements: {
    rootBox: {
      width: '100%',
    },
    card: {
      background: '#F5F2EC',
      border: '1px solid #E2DCCF',
      boxShadow: 'none',
      borderRadius: '1px',
      padding: '40px',
    },
    headerTitle: {
      display: 'none',
    },
    headerSubtitle: {
      fontFamily: 'Inter, sans-serif',
      color: '#6B6E76',
      fontSize: '15px',
    },
    formFieldLabel: {
      fontSize: '11px',
      letterSpacing: '0.16em',
      textTransform: 'uppercase',
      color: '#6B6E76',
      fontWeight: 500,
    },
    formFieldInput: {
      background: 'transparent',
      border: 'none',
      borderBottom: '1px solid #E2DCCF',
      borderRadius: 0,
      padding: '10px 12px',
      fontSize: '16px',
      color: '#1A1D24',
      transition: 'border-color 200ms ease',
      '&:focus': {
        borderBottomColor: '#1A1D24',
        boxShadow: 'none',
      },
      '&::placeholder': {
        textTransform: 'uppercase',
        letterSpacing: '0.16em',
        fontSize: '12px',
        color: '#A4A39C',
        opacity: 1,
      },
      '&::-webkit-input-placeholder': {
        textTransform: 'uppercase',
        letterSpacing: '0.16em',
        fontSize: '12px',
        color: '#A4A39C',
      },
    },
    // Match the public-site .btn-primary: cream fill with bordeaux border,
    // fills bordeaux on hover.
    formButtonPrimary: {
      background: '#F5F2EC',
      color: '#2C2F36',
      border: '1px solid #5A2A2A',
      borderRadius: '1px',
      padding: '14px 26px',
      fontSize: '14px',
      letterSpacing: '0.08em',
      fontWeight: 500,
      textTransform: 'none',
      boxShadow: 'none',
      transition: 'background 200ms ease, color 200ms ease',
      '&:hover': {
        background: '#5A2A2A',
        color: '#F5F2EC',
        boxShadow: 'none',
      },
      '&:focus': {
        boxShadow: 'none',
      },
    },
    socialButtonsBlockButton: {
      border: '1px solid #E2DCCF',
      borderRadius: '1px',
      color: '#1A1D24',
      '&:hover': {
        background: '#EEEAE1',
      },
    },
    dividerLine: {
      background: '#E2DCCF',
    },
    dividerText: {
      color: '#A4A39C',
      fontSize: '11px',
      letterSpacing: '0.16em',
      textTransform: 'uppercase',
    },
    footerActionText: {
      color: '#6B6E76',
      fontSize: '13px',
    },
    footerActionLink: {
      color: '#5A2A2A',
      borderBottom: '1px solid transparent',
      '&:hover': {
        color: '#5A2A2A',
        borderBottomColor: '#5A2A2A',
      },
    },
    identityPreviewText: {
      color: '#1A1D24',
    },
    identityPreviewEditButton: {
      color: '#5A2A2A',
    },
  },
};

const SignInPage = () => {
  return (
    <div className="page-enter" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <SiteNav />
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          padding: '80px 24px 120px',
        }}
      >
        <div style={{ width: '100%', maxWidth: 460 }}>
          <SignIn
            routing="hash"
            redirectUrl="/dashboard"
            appearance={clerkAppearance}
          />
        </div>
      </div>
      <MinimalFooter />
    </div>
  );
};

export default SignInPage;
